/* eslint-disable */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useGetDraftByYearQuery } from '../api/draft-tracker-api';

export function useDraftTrackerLeaderboardRefetch(
    year,
    pollingDelay = PULSE.app.common.CONSTANTS.TIME.THIRTY_SECS_IN_MS,
    eventStartDateTime = '1970-01-01T00:00:00Z'
) {
    const [pollingInterval, setPollingInterval] = useState(0);
    const token = useSelector(PULSE.app.redux.selectors.token.selectToken);

    const { data: draftData, isFetching } = useGetDraftByYearQuery(year, {
        pollingInterval,
        skip: !(year && year !== '') || !token
    });

    useEffect(() => {
        if (draftData && !isFetching) {
            const draftStatus = draftData?.status;
            const lastPick = draftData?.selections.length
                ? draftData.selections[draftData.selections.length - 1]
                : null;

            if (
                lastPick?.fullName ||
                lastPick?.passed ||
                draftStatus === PULSE.app.common.CONSTANTS.DRAFT_STATUS.COMPLETE
            ) {
                setPollingInterval(0);
            } else if (
                draftStatus === PULSE.app.common.CONSTANTS.DRAFT_STATUS.LIVE
            ) {
                setPollingInterval(pollingDelay);
            } else {
                const interval =
                    PULSE.app.common.getPollingInterval(eventStartDateTime);
                setPollingInterval(interval);
            }
        }
    }, [draftData, isFetching, eventStartDateTime, pollingDelay]);

    return { draftData, isFetching, pollingInterval };
}
